import { useContext } from 'react'
import { useAsyncFn } from 'react-use'
import axios from 'axios'
import { config } from '../../../config'
import { ContextShell } from '../../../modules/context'

interface UseStripePortalUrl {
  loading: boolean
  error?: Error | undefined
  value?: string | undefined
  getStripePortalUrl(): Promise<string>
}

export const useStripePortalUrl = (): UseStripePortalUrl => {
  const { userToken } = useContext(ContextShell)

  const [state, getStripePortalUrl] = useAsyncFn(async () => {
    const resp = await axios.get(
      `${config.serviceBillingApi.endpoint}/v1/stripe/get-customer-portal-url`,
      {
        headers: {
          Authorization: userToken
        }
      }
    )

    return resp.data?.url
  }, [userToken])

  return {
    ...state,
    getStripePortalUrl
  }
}
